import React from 'react'
import AggregatorComponentMain from './AggregatorComponent'

export default function FinancialPL({allDetail}) {
  return (
    <div>
         <div className="container-fluid details-body-credit full-height credit-module">
             <div className="row" >
                 <div className=" col-xs-12 " style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.25)', minHeight: '440px' }}>
                       <div style={{ margin: '20px 0' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h4><i class="fa fa-server"></i> &nbsp; Financial Details</h4>

                    
                            </div>
                            <hr />
                       </div>
                        <AggregatorComponentMain allDetail={allDetail}  />
                 </div>
             </div>
         </div>
    </div>
  )
}
